export default {
	/**
	 * Resolves an array of client objects from the API.
	 *
	 * @returns {Promise<array>}
	 */
	async all () {},

	/**
	 * Resolves an array of device types from the given client ID.
	 *
	 * @param {int} clientId The client ID to filter
	 * @returns {Promise<array>}
	 */
	async getFromClient (clientId) {}
};
